import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createButton } from './Button';
import { BUTTON_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(BUTTON_BASE_CLASSNAME), createButton, NO_PATTERN_BUSINESS_LOGIC);
